

























































































































































































































































































































































































































































































































































































































import { Component, Prop, Vue, Watch, Mixins } from 'vue-property-decorator'
import addTaskMixin from './addTaskMixin'
import UploadData from './UploadData.vue'

@Component({
	components: {
		UploadData,
	},
})
export default class Settle extends Mixins(addTaskMixin) {
	public taskType: any = '10'
	private submitting: boolean = false

	// 这三个都是详情中使用,用于展示图片和修改图片
	// private mediaInfo: any = {
	// 	baseMediaInfoList: [
	// 		{
	// 			picName: '案件传票',
	// 			type: '0001',
	// 			picId: '61a1bd06f5f048c3862cab605a724048',
	// 			picUrl:
	// 				'http://devmedia.cias.cn/ca55835eb38f4022b8cdd1df97dc7295/32fe0dff0a9a41cab1760f8e3ce0dd63',
	// 			orderNum: 1,
	// 		},
	// 		{
	// 			picName: '案件诉状',
	// 			type: '0002',
	// 			picId: '61a1bd06f5f048c3862cab605a724048',
	// 			picUrl:
	// 				'http://devmedia.cias.cn/ca55835eb38f4022b8cdd1df97dc7295/32fe0dff0a9a41cab1760f8e3ce0dd63',
	// 			orderNum: 1,
	// 		},
	// 	],
	// 	injuredMediaInfoList: [],
	// 	deathMediaInfoList: [],
	// }
	private isReadonly: boolean = false
	private onUploadDataChange(res: any) {
		// console.log(res)
	}
}
